<template>
  <div>
    <v-container class="fill-height pa-0" fluid>
      <v-row class="fill-height pa-0 mx-0 my-auto">
        <v-col cols="12" class="d-flex pa-0 text-center justify-center">
          <p class="font-weight-bold neutral--text pb-4 pt-6">{{ 'Accept Offer' }}</p>
        </v-col>
        <v-col cols="12" class="pa-0" v-if="!orderSubmitted">
          <v-form ref="form" v-model="valid" :lazy-validation="false">
            <v-row>
              <v-col cols="12">
                <label>Comments</label>
                <v-textarea
                  v-model="order.comments"
                  :placeholder="'Comments'"
                  :rules="requiredRule()"
                  class="required"
                  outlined
                  clearable
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>

          <v-row style="width: 100%">
            <v-col cols="12">
              <v-btn
                :disabled="!valid"
                block
                depressed
                rounded
                large
                class="white--text font-weight-bold"
                color="black"
                @click="submitOrderOffer"
                >{{ 'Accept' }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else cols="12" class="pa-0">
          <v-alert dense text type="success">
            Offer <strong>successfully</strong> accepted
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import EventBus from '@/helpers/event-bus';
import util from '@/mixins/util';

export default {
  name: 'OrderAcceptedByResearcher',
  mixins: [util],
  data() {
    return {
      valid: false,
      order: {
        uuid: null,
        type: null,
        comments: null,
      },
      orderSubmitted: false,
    };
  },
  mounted() {
    this.order.uuid = this.$route.query.uuid;
    this.order.type = this.$route.query.type;
  },
  methods: {
    submitOrderOffer() {
      EventBus.$emit('waiting', true);
      if (this.order.type === 'equipment') {
        this.axios
          .put('/api/v1/orders-equipment/accept-by-researcher?uuid=' + this.order.uuid, this.order)
          .then(() => {
            console.log('Success');
            EventBus.$emit('snackbar', {
              text: 'Offer successfully accepted',
            });
            this.orderSubmitted = true;
          })
          .catch(error => {
            console.log(error);
          })
          .finally(EventBus.$emit('waiting', false));
      } else if (this.order.type === 'patent') {
        this.axios
          .put('/api/v1/orders-patent/accept-by-researcher?uuid=' + this.order.uuid, this.order)
          .then(() => {
            console.log('Success');
            EventBus.$emit('snackbar', {
              text: 'Offer successfully accepted',
            });
            this.orderSubmitted = true;
          })
          .catch(error => {
            console.log(error);
          })
          .finally(EventBus.$emit('waiting', false));
      } else {
        this.axios
          .post('/api/v1/orders/accept-by-researcher?uuid=' + this.order.uuid, this.order)
          .then(() => {
            console.log('Success');
            EventBus.$emit('snackbar', {
              text: 'Offer successfully accepted',
            });
            this.orderSubmitted = true;
          })
          .catch(error => {
            console.log(error);
          })
          .finally(EventBus.$emit('waiting', false));
      }
    },
  },
};
</script>
